<template>
    <div class="main p-r f f--c">
        <div class="switchIcon f-c">
            <i class="el-icon-arrow-left pointer" v-if="orderItems.length > 3" @click="imageSwitch('left')"></i>
        </div>
        <div class="viewport p-r f">
            <div class="f content" :id="`${randomTime}`" :style="{left: `${leftDistance}px`}">
                <div class="item pointer" v-for="(item, index) in orderItems" :key="`${item.imageUrl}${index}`" @click="showOutOfStockVisible">
                    <div style="position: relative;">
                        <div v-if="item.isOutOfStock === 1 || (item.skuStatus && item.skuStatus !== 1)" class="sold-out f-c-c">Sold Out</div>
                        <div v-if="item.productType === 3" class="tag-pod f-c-c">POD</div>
                        <el-image :src="item.imageUrl"></el-image>
                    </div>
                </div>
            </div>
        </div>
        <div class="switchIcon f-c">
            <i class="el-icon-arrow-right pointer" v-if="orderItems.length > 3" @click="imageSwitch('right')"></i>
        </div>
        <el-dialog title="缺货标记" :visible.sync="outOfStockVisible" width="800px" @open="handleOpen" :modal="false">
            <p style="margin-bottom:15px;">选择缺货的商品进行标记</p>
            <el-checkbox v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
            <div v-for="(item,index) in orderItems" :label="item.skuCode" :key="index" :disabled="item.isOutOfStock === 1">
                <div class="f-b" style="margin-top:10px;width: 700px">
                    <div class="f">
                        <div style="margin-right: 8px">
                            <el-checkbox  v-model="item.checked" @change="value => itemCheck(value, item)"></el-checkbox>
                        </div>
                        <el-popover placement="right" width="280" trigger="hover">
                            <el-image :src="item.imageUrl" fit="cover" />
                            <el-image :src="item.imageUrl" fit="cover" slot="reference" style="width:80px;height: 80px;" />
                        </el-popover>
                        <div class="good-describe ellipsis" style="width:258px;margin-left: 15px;">
                            <p class="ellipsis">{{defaultTips(item.productName)}}</p>
                            <p class="ellipsis">{{options(item.options)}}</p>
                            <p class="ellipsis">
                                <copy :text="item.skuCode">{{defaultTips(item.skuCode)}}</copy>
                            </p>
                        </div>
                    </div>
                    <div class="f--c" style="width: 120px">
                        <div>
                            <span>USD {{item.finalAmount}}</span>
                            <span>X {{item.productNum}}</span>
                        </div>
                    </div>
                    <div class="f-c-c" style="width: 100px">
                        <el-button type="text" @click="handleOutOfStockStatus(item, 0)" v-if="item.isOutOfStock === 0">标记</el-button>
                        <el-button type="text" @click="handleOutOfStockStatus(item, 1)" v-else>取消标记</el-button>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button :loading="loading" @click="handleOutOfStockClose">取消</el-button>
                <el-button :loading="loading" @click="handleCheckOutOfStock(1)">批量取消标记</el-button>
                <el-button :loading="loading" type="primary" @click="handleCheckOutOfStock(0)">批量标记</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import moment from 'moment'
import API from '@/api'
import copy from '@/components/copy.vue'

export default {
    props: {
        orderItems: {
            type: Array,
            default: () => []
        },
        order: {
            type: Object,
            default: () => ({})
        }
    },
    components: {
        copy
    },
    data() {
        return {
            leftDistance: 0,
            randomTime: moment().valueOf(),
            arr: [],
            outOfStockVisible: false,
            isIndeterminate: false,
            checkAll: false,
            loading: false
        }
    },
    created() {
        // this.arr = JSON.parse(JSON.stringify(this.orderItems))
        // this.arr.push({imageUrl: 'https://hbo-shenzhen.oss-cn-shenzhen.aliyuncs.com/web-img/feedback_3.png'})
        // this.arr.push({imageUrl: 'https://hbo-shenzhen.oss-cn-shenzhen.aliyuncs.com/web-img/image%2012820010.png'})
        // this.checkAll = this.orderItems
    },
    computed: {
        defaultTips() {
            return (value) => value || '-'
        },
        options() {
            return (options) => {
                let value = []
                JSON.parse(options) && JSON.parse(options).forEach((item) => {
                value.push(JSON.parse(item).value)
                })
                return value.join('、')
            }
        },
        outOfStockList() {
            return this.orderItems.filter(e=>e.isOutOfStock !== 1)
        }
    },
    methods: {
        showOutOfStockVisible() {
            if (['waiting_payment', 'abnormal_order'].includes(this.order.status)) return
            this.outOfStockVisible = true
        },
        imageSwitch(direction) {
            let moveDistance = direction === 'left' ? 60: -60
            const myContent = document.getElementById(this.randomTime)
            let basicLeft = +myContent.style.left.slice(0, -2)
            let leftBoundary = 0
            let rightBoundary = 0
            if(this.orderItems.length > 3) {
                leftBoundary = -((this.orderItems.length - 3) * 60)
            }
            if(direction === 'left' && basicLeft === 0) {
                myContent.style.left
                return
            }
            if(direction === 'right' && (basicLeft + moveDistance) <= leftBoundary ) {
                myContent.style.left = `${leftBoundary}px`
                return
            }
            myContent.style.left = `${basicLeft + moveDistance}px`
        },
        handleClose() {},
        handleOpen() {
            this.checkAll = false
            this.orderItems.forEach(e=>{
                this.$set(e, 'checked', false)
            }) 
        },
        handleOutOfStockClose() {
            this.checkAll = false
            this.orderItems.forEach(e=>{
                this.$set(e, 'checked', false)
            })
            this.outOfStockVisible = false
            this.isIndeterminate=false
        },
        handleCheckAllChange(check) {
            this.orderItems.forEach(e=>{
                this.$set(e, 'checked', check)
            })
        },
        handleCheckOutOfStock(type){
            this.handleOutOfStock(this.order.kkOrderId, this.orderItems.filter(e=>e.checked).map(e=>e.skuCode), type)
        },
        handleOutOfStock(kkOrderId, skuCodes, type) {
            if (!skuCodes || skuCodes.length <= 0) {
                return this.$message.warning('请选择商品')
            }
            API.handleOutOfStock(kkOrderId, { skuCodes: skuCodes, type }).then(res => {
                if (res.code === 10000) {
                    this.$message.success(`${skuCodes.toString()} 操作成功`)
                    this.handleOutOfStockClose()
                    this.$emit('batchOutOfStockSubmit')
                }
            }).catch(error => {
                this.$message.error(error.data.message)
            })
        },
        handleOutOfStockStatus(item, type) {
            item.isOutOfStock = type === 1 ? 0: 1
            this.handleOutOfStock(this.order.kkOrderId, [item.skuCode], type)
        },
        itemCheck(value, item) {
            this.$set(item, 'checked', value)
            this.checkAll = this.orderItems.every(e=>e.checked)
        }
    },
}
</script>

<style lang="scss" scoped>
.main{
    .viewport{
        height: 60px;
        overflow-x: hidden;
        width: 170px;
        .content{
            position: absolute;
            left: 0;
            top: 0;
            animation-duration: 2s;
            .item{
                margin-right: 10px;
                .el-image{
                    width: 50px;
                    height: 50px;
                }
                .sold-out{
                    z-index: 10;
                    background: rgba(0, 0, 0, 0.37);
                    position: absolute;
                    width:54px;
                    height: 50px;
                    color: #fff;
                    font-size: 10px;
                    top: 0;
                    left: -2px;
                }
                .tag-pod {
                    position: absolute;
                    bottom: 8px;
                    width: 100%;
                    height: 14px;
                    font-size: 12px;
                    line-height: 14px;
                    text-align: center;
                    color: #9AC331;
                    background-color: #F7FCEB;
                    z-index: 11;
                }
            }
        }
    }
    .switchIcon{
        width: 10px;
        height: 10px;
        margin: 4px;
    }
    .good-describe {
        width: 228px;
        line-height: 19px;
        }
}
</style>